export const BASE_API_URL = process.env.VUE_APP_REST_API_BASE_URL || ''
export const USER_SESSION_API_URL =
  process.env.VUE_APP_USER_SESSION_API_URL || ''
export const API_TIMEOUT = 10000
